var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMineVip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_mine_vip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u6211\\u7684\\u4FE1\\u606F",
    transform: "translate(-477, -550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mine_vip",
    transform: "translate(475, 547)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87955651,8.2650837 L4.95582956,17.3401808 L17.0440804,17.3401808 L18.1203339,8.2650837 L14.7643509,10.4834408 L10.9999452,5.25747952 L7.23553946,10.4834408 L3.87955651,8.2650837 Z M3.30124854,5.88738337 L6.81542617,8.2111264 L10.3186979,3.34785004 C10.4757735,3.12956868 10.7295274,3 10.9999452,3 C11.2703629,3 11.5241169,3.12956868 11.6811925,3.34785004 L15.1844642,8.2111264 L18.6994657,5.88738337 C18.9710938,5.70816321 19.3229888,5.70181245 19.6010132,5.87111285 C19.8790377,6.04041326 20.0325039,6.35449908 19.9941905,6.6757941 L18.6191424,18.2671805 C18.5695007,18.6850368 18.2123865,19 17.7880956,19 L4.21181438,19 C3.78752346,19 3.43040925,18.6850368 3.3807676,18.2671805 L2.00569982,6.67495771 C1.96777165,6.35381472 2.12138334,6.04006492 2.39931921,5.87099544 C2.67725508,5.70192595 3.02890779,5.70832142 3.3004051,5.88738337 L3.30124854,5.88738337 Z M10.9999452,14.0205229 C10.0755235,14.0205229 9.3261317,13.2773921 9.3261317,12.3606939 C9.3261317,11.4439957 10.0755235,10.700865 10.9999452,10.700865 C11.9243668,10.700865 12.6737587,11.4439957 12.6737587,12.3606939 C12.6737587,13.2773921 11.9243668,14.0205229 10.9999452,14.0205229 Z",
    id: "\\u5F62\\u72B6",
    fill: "#999999",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMineVip);
export default __webpack_public_path__ + "static/media/icon_mine_vip.svg";
export { ForwardRef as ReactComponent };